import { useErrorBoundary } from 'react-error-boundary';

import { MainLayout } from '@app/layout/MainLayout';
import ServerErrorPage from '@app/pages/ServerErrorPage';

export function ErrorFallback() {
  const { resetBoundary } = useErrorBoundary();

  return (
    <MainLayout>
      <ServerErrorPage onBackBtnClick={resetBoundary} onRefreshPageBtnClick={resetBoundary} />
    </MainLayout>
  );
}
